import { render, staticRenderFns } from "./bindpublicAccount.vue?vue&type=template&id=137a13d6&scoped=true"
import script from "./bindpublicAccount.vue?vue&type=script&lang=js"
export * from "./bindpublicAccount.vue?vue&type=script&lang=js"
import style0 from "./bindpublicAccount.vue?vue&type=style&index=0&id=137a13d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "137a13d6",
  null
  
)

export default component.exports